export default {
  en: {
    title: 'Not found what you\'re looking for?',
    subtitle: 'This email address isn’t associated with any active accounts within the ClassForKids platform. Please check you are using the correct login details or email <a href="mailto:support@class4kids.co.uk">support@class4kids.co.uk</a>',
  },
};
